// German translations for Oh Mind Guide
// AI-generated first pass — review and refine as needed

export const de = {
  // Navigation
  nav: {
    articles: "Lernen",
    games: "Gehirntraining",
    exercises: "Sofort besser fühlen",
    questionnaires: "Check-in",
    contact: "Kontakt",
  },
  
  // Home page
  home: {
    hero: {
      title1: "Oh Mind Guide",
      title2: "Wo Neurowissenschaft",
      title3: "den Alltag trifft auf einem",
      title4: "bunten Spielplatz f\u00FCr deinen Geist",
      subtitle: "Artikel, Spiele, Übungen und Fragebögen für die Widerstandsfähigkeit des Gehirns und Lebensqualität - evidenzbasiert und einfach zu nutzen.",
      exploreBtn: "Oh Mind Guide entdecken",
      contactBtn: "Kontakt",
    },
    heroCircle: {
      centerText: "Wähle deinen eigenen Weg",
      learn: "Lernen",
      learnHelper: "Kurze, klare Erklärungen zu Gehirnwissenschaft und psychischem Wohlbefinden",
      trainBrain: "Gehirntraining",
      trainBrainHelper: "Spielerische Herausforderungen für Aufmerksamkeit, Gedächtnis und Flexibilität",
      feelBetter: "Sofort besser fühlen",
      feelBetterHelper: "Geführte Mikro-Übungen zur Stressreduktion und schärferen Konzentration",
      checkIn: "Check-in",
      checkInHelper: "Wissenschaftsbasierte Selbstreflexions-Tools für Stimmung, Schlaf und Stress",
    },
    about: {
      title: "Was ist Oh Mind Guide?",
      p1: "Oh Mind Guide ist ein spielerischer, wissenschaftsbasierter Ort, um zu entdecken, wie dein Gehirn und Geist funktionieren - und um sie aktiv, flexibel und widerstandsfähig zu halten.",
      p2: "Wir verwandeln Erkenntnisse aus Neurowissenschaft und Psychologie in klare Erklärungen und praktische Werkzeuge für den Alltag - durch Artikel, Spiele, Übungen und Fragebögen.",
      p3: "",
      brainResilience: "Gehirn-Resilienz",
      brainResilienceDesc: "Trainiere Aufmerksamkeit, Gedächtnis und Flexibilität.",
      qualityOfLife: "Lebensqualität",
      qualityOfLifeDesc: "Unterstütze Stimmung, Energie und alltägliche Funktionsfähigkeit.",
      scienceBased: "Wissenschaftsbasiert",
      scienceBasedDesc: "Verwurzelt in aktueller Neurowissenschaft und Psychologieforschung.",
      playfulLearning: "Spielerisches Lernen",
      playfulLearningDesc: "Unterhaltsam, ansprechend und nachhaltig gestaltet.",
    },
    founder: {
      title: "Über mich",
      name: "Margarita Popelnyukhova",
      subtitle: "Ärztin (MD), MSc Translationale Neurowissenschaft und Gründerin von Oh Mind Guide.",
      description: "Ich verbinde klinische Erfahrung mit Hirnforschung, um Werkzeuge zu entwickeln, die sowohl spielerisch als auch evidenzbasiert sind. Ich widme mich der Erweiterung der Grenzen der Hirnforschung und der Übersetzung komplexer Neurowissenschaft in einfache, ansprechende Erlebnisse für den Alltag.",
      badge1: "Ärztin (MD)",
      badge2: "MSc Translationale Neurowissenschaft",
      badge3: "Gründerin von Oh Mind Guide",
    },
    who: {
      title: "Für wen ist Oh Mind Guide",
      parents: "Eltern & Pädagogen",
      parentsDesc: "Unterstütze Kinder und Jugendliche mit sinnvollen, gehirnfreundlichen Aktivitäten und Gesprächen.",
      students: "Studierende",
      studentsDesc: "Stärke Fokus, Lernen und mentale Ausdauer mit praktischen, wissenschaftsbasierten Werkzeugen.",
      adults: "Neugierige Erwachsene",
      adultsDesc: "Halte deinen Geist flexibel, kreativ und engagiert - auf eine unterhaltsame, zugängliche Weise.",
      older: "Ältere Erwachsene",
      olderDesc: "Erhalte kognitive Funktionen und bleibe geistig aktiv mit sanften, ansprechenden Übungen.",
    },
    what: {
      title: "Was wir schaffen",
      subtitle: "Alles basiert auf wissenschaftlich fundierten Methoden, inspiriert von aktueller Forschung in Neurowissenschaft und Psychologie.",
      articlesTitle: "Lernen",
      articlesDesc: "Kurze, klare Erklärungen zu Gehirnwissenschaft, gehirnbezogenen Erkrankungen und psychischem Wohlbefinden - in Alltagssprache übersetzt.",
      articlesLink: "Jetzt lernen \u2192",
      gamesTitle: "Gehirntraining",
      gamesDesc: "Spielerische Herausforderungen für Aufmerksamkeit, Gedächtnis, Flexibilität und Problemlösung.",
      gamesLink: "Jetzt trainieren \u2192",
      exercisesTitle: "Sofort besser fühlen",
      exercisesDesc: "Geführte Mikro-Übungen zur Stressreduktion, schärferen Konzentration und allgemeinen Gehirngesundheit.",
      exercisesLink: "Übungen ausprobieren \u2192",
      questionnairesTitle: "Check-in",
      questionnairesDesc: "Wissenschaftsbasierte Selbstreflexions-Tools für Stimmung, Angst, Schlaf und Stresslevel.",
      questionnairesLink: "Check-in starten \u2192",
      cafeTitle: "OMG Cafe",
      cafeDesc: "Bestelle ein Getränk, merke dir Wörter während es zubereitet wird, und schau wie viele du erinnerst. Ein gemütliches Gedächtnisritual.",
      cafeLink: "Cafe besuchen \u2192",
      photoBoothTitle: "Fotobox",
      photoBoothDesc: "Ein Tool zum Festhalten von Momenten. Mache 4 schnelle Schnappschüsse und bekomme einen Fotostreifen.",
      photoBoothLink: "Fotos machen \u2192",
    },
    whatsNext: {
      title: "Was kommt als Nächstes",
      dementiaGuideTitle: "Familienratgeber für Demenz",
      dementiaGuideDesc: "Ein herunterladbarer, druckbarer Ratgeber für Angehörige von Menschen mit Demenz, mit klaren Erklärungen zu Gehirn- und Verhaltensänderungen, praktischen Tipps für Alltagssituationen und sanften Übungen zur Unterstützung.",
      dementiaGuideStatus: "In Arbeit",
      podcastTitle: "\"Von Mensch zu Mensch\"",
      podcastDesc: "Video-/Podcast-Serie.",
      podcastStatus: "Demnächst",
      trainerTitle: "Interhemisphärischer Interaktionstrainer",
      trainerDesc: "Eine Reihe spielerischer Übungen zur Stärkung der Kommunikation zwischen linker und rechter Gehirnhälfte - für Koordination, Aufmerksamkeit und kognitive Flexibilität.",
      trainerStatus: "In Entwicklung",
    },
    contact: {
      title: "Lass uns verbinden",
      subtitle: "Hast du eine Idee für eine Zusammenarbeit, ein Projekt oder eine Frage? Ich würde mich freuen, von dir zu hören. Schreib mir und lass uns sehen, was wir gemeinsam schaffen können.",
      emailBtn: "Oh Mind Guide schreiben",
    },
    faq: {
      title: "Häufig gestellte Fragen",
      q1: "Was ist Oh Mind Guide?",
      a1: "Oh Mind Guide ist ein wissenschaftsbasiertes Projekt, das komplexe Neurowissenschaft, Psychologie und medizinische Forschung in klares, nutzbares Wissen für den Alltag übersetzt. Es ist eine Brücke zwischen wissenschaftlicher Forschung und realem Leben: Statt vager \"Mental-Health-Tipps\" findest du hier evidenzbasierte Artikel, kurze Spiele und Übungen sowie praktische Check-ins (Fragebögen), die dir helfen, deinen Geist, dein Gehirn und deine Gewohnheiten zu verstehen - ohne Fachjargon. Oh Mind Guide geht nicht darum, dich zu \"reparieren\". Es geht darum zu lernen, wie dein Geist funktioniert, bessere Werkzeuge aufzubauen und neugierig zu bleiben. Du bist noch in Arbeit.",
      q2: "Ist der Inhalt wissenschaftlich fundiert?",
      a2: "Ja - der Inhalt auf Oh Mind Guide ist wissenschaftlich fundiert gestaltet. Artikel werden auf Basis zuverlässiger Forschung in Neurowissenschaft, Psychologie und Medizin verfasst, und Quellen werden soweit möglich angegeben. Spiele und Übungen basieren auf evidenzbasierten Prinzipien, wie das Gehirn lernt, fokussiert, erinnert und Stress reguliert. Fragebögen werden nach publizierten Validierungskriterien (oder starker klinischer/Forschungsnutzung) ausgewählt und als Check-in-Tool präsentiert - nicht als Diagnose. Hinweis: Oh Mind Guide dient der Bildung und Selbsterkenntnis und ersetzt keine professionelle medizinische Beratung oder Behandlung.",
      q3: "Wer erstellt die Inhalte?",
      a3: "Alle Inhalte auf Oh Mind Guide werden von Margarita Popelnyukhova erstellt - Ärztin mit einem MSc in Translationaler Neurowissenschaft und Gründerin von Oh Mind Guide.",
      q4: "Ist Oh Mind Guide kostenlos?",
      a4: "Ja, alle Artikel, Gehirnspiele, Übungen und Fragebögen auf Oh Mind Guide sind komplett kostenlos zugänglich. Wir glauben, dass jeder Zugang zu evidenzbasierten Ressourcen für die Gehirngesundheit haben sollte.",
      q5: "Wie wählt ihr Quellen und Forschung für Oh Mind Guide aus?",
      a5: "Ich stütze mich auf hochwertige, evidenzbasierte Quellen. Wenn möglich, priorisiere ich systematische Reviews und Meta-Analysen, große gut angelegte Studien und anerkannte klinische Leitlinien oder Konsensus-Erklärungen. Ich prüfe auch, ob Ergebnisse repliziert wurden, wie stark der Effekt ist und ob die Erkenntnisse auf den Alltag anwendbar sind. Für psychische Gesundheitsfragebögen verwende ich validierte, weit verbreitete Instrumente und verlinke zu den Originalquellen. Ich versuche, die Wissenschaft präzise in einfacher Sprache zusammenzufassen und keine Behauptungen aufzustellen, die über die Evidenz hinausgehen.",
      q6: "Wie oft werden die Inhalte aktualisiert?",
      a6: "Wichtige Seiten werden regelmäßig überprüft und aktualisiert, wenn neue zuverlässige Evidenz erscheint. Als Basis strebe ich an, Kernratgeber und die meistbesuchten Seiten mindestens alle 1-2 Monate zu überprüfen und aufzufrischen, und ich aktualisiere ältere Artikel, wenn wichtige neue Studien oder Leitlinien das Bild ändern. Bei Aktualisierungen überarbeite ich die Quellen und passe die Erkenntnisse an, damit sie aktuell und genau bleiben. Du siehst ein \"Letzte Aktualisierung\"-Datum auf Seiten, die überprüft wurden.",
    },
    footer: {
      copyright: "\u00A9 {year} OMG GTM Solutions L.L.C-FZ. Alle Rechte vorbehalten.",
    },
    newHere: {
      title: "Neu hier?",
      whatIsTitle: "Was ist Oh Mind Guide",
      whatIsDesc: "Ein wissenschaftsbasierter Spielplatz für kognitives Wohlbefinden.",
      whatIsLink: "Mehr über unsere Mission erfahren",
      aboutTitle: "Über die Gründerin",
      aboutDesc: "Margarita Popelnyukhova, MD + MSc Translationale Neurowissenschaft.",
      aboutLink: "Meine Geschichte lesen",
      faqTitle: "FAQ & Standards",
      faqDesc: "Wie Inhalte ausgewählt werden, wie oft aktualisiert wird, Haftungsausschlüsse.",
      faqLink: "FAQ ansehen",
    },
    backToHome: "Zurück zur Startseite",
  },
  
  // Articles page
  articles: {
    title: "Lernen",
    subtitle: "Kurze, klare Erklärungen zu Gehirnwissenschaft, gehirnbezogenen Erkrankungen und psychischem Wohlbefinden - in Alltagssprache übersetzt.",
    categories: {
      lifestyle: "Lebensstil",
      foundations: "Grundlagen",
      brainMentalHealth: "Gehirn & Psychische Gesundheit",
    },
    backToAllArticles: "Zurück zu allen Artikeln",
    readArticle: "Artikel lesen \u2192",
    comingSoon: "Demnächst",
    moreArticles: "Weitere Artikel in Kürze",
    moreArticlesDesc: "Wir arbeiten an weiteren wissenschaftsbasierten Ratgebern über Gehirngesundheit, Lernen, Stimmung und Altern. Bleib dran!",
    filterByTopic: "Nach Thema filtern:",
    disclaimer: "Haftungsausschluss",
    disclaimerText: "Diese Artikel dienen nur der allgemeinen Bildung und ersetzen keine ärztliche Beratung oder Untersuchung. Wenn du dir Sorgen um dich selbst oder jemanden machst, der dir wichtig ist, sprich bitte mit einer qualifizierten Fachperson.",
    clearFilters: "Filter zurücksetzen",
    
    tags: {
      foundations: "Grundlagen",
      sleep: "Schlaf",
      stress: "Stress",
      mentalHealth: "Psychische Gesundheit",
      movement: "Bewegung",
      neurodevelopment: "Neuroentwicklung",
      ageing: "Altern",
      neurodegeneration: "Neurodegeneration",
    },
    
    brainAndMind: {
      title: "Gehirn und Geist",
      desc: "Wie physisches Gewebe Gedanken, Gefühle und Selbst hervorbringt",
      badge1: "Grundlagen",
      badge2: "Bewusstsein",
      subtitle: "Wie physisches Gewebe Gedanken, Gefühle und Selbst hervorbringt",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche Beratung oder Untersuchung. Wenn du dir Sorgen machst, sprich bitte mit einer qualifizierten Fachperson.",
      backToArticles: "Zurück zu allen Artikeln",
    },
    dementia: {
      title: "Demenz",
      desc: "Was es ist, warum es passiert und was wir tun können",
      badge1: "Gehirngesundheit",
      badge2: "Altern",
      subtitle: "Was es ist, warum es passiert und was wir tun können",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche Beratung oder Untersuchung. Wenn du dir Sorgen machst, sprich bitte mit einer qualifizierten Fachperson.",
      backToArticles: "Zurück zu allen Artikeln",
    },
    parkinsons: {
      title: "Parkinson-Krankheit",
      desc: "Die Grundlagen, die Wissenschaft und die Zukunft verstehen",
      badge1: "Gehirngesundheit",
      badge2: "Bewegung",
    },
    adhd: {
      title: "ADHS",
      desc: "Mehr als \"Hyperaktivität\": Wie ADHS das Gehirn beeinflusst",
      badge1: "Gehirngesundheit",
      badge2: "Neuroentwicklung",
      badge3: "Bildung",
      subtitle: "Neuroentwicklungsstörung mit Aufmerksamkeits- und Impulsivitäts-Herausforderungen",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche Beratung. Wenn du dir Sorgen machst, sprich bitte mit einer qualifizierten Fachperson.",
    },
    sleep: {
      title: "Schlaf & das Gehirn",
      desc: "Wie Schlaf Gedächtnis, Stimmung und Gehirngesundheit über die Lebensspanne unterstützt",
      badge1: "Gehirngesundheit",
      badge2: "Schlafwissenschaft",
      subtitle: "Schlafphasen, Gedächtniskonsolidierung, Gehirn-\"Reinigung\" und altersspezifische Tipps",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche Beratung. Wenn du dir Sorgen machst, sprich bitte mit einer qualifizierten Fachperson.",
    },
    autism: {
      title: "Autismus-Spektrum-Störung",
      desc: "Was es ist, was wir über das Gehirn wissen und wie man autistische Menschen unterstützen kann",
      badge1: "Gehirngesundheit",
      badge2: "Neuroentwicklung",
      subtitle: "Was es ist, was wir über das Gehirn wissen und wie man autistische Menschen über die Lebensspanne unterstützen kann",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche oder psychologische Beratung. Wenn du dir Sorgen machst, sprich bitte mit einer qualifizierten Fachperson.",
    },
    schizophrenia: {
      title: "Schizophrenie",
      desc: "Symptome, Gehirnwissenschaft, Risikofaktoren und erholungsorientierte Behandlung",
      badge1: "Gehirngesundheit",
      badge2: "Psychische Gesundheit",
      subtitle: "Symptome, Gehirnwissenschaft, Risikofaktoren und erholungsorientierte Behandlung",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche Beratung. Wenn du dir Sorgen machst, sprich bitte mit einer qualifizierten Fachperson oder dem Notdienst.",
    },
    anxiety: {
      title: "Angst",
      desc: "Wenn das Alarmsystem des Gehirns auf \"hoch\" stecken bleibt",
      badge1: "Gehirngesundheit",
      badge2: "Psychische Gesundheit",
      subtitle: "Wenn das Alarmsystem des Gehirns auf \"hoch\" stecken bleibt",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche oder psychologische Beratung. Bei unmittelbarer Gefahr kontaktiere bitte den Notdienst oder eine Krisenhotline.",
    },
    depression: {
      title: "Depression",
      desc: "Wenn das Stimmungssystem des Gehirns im Leerlauf hängen bleibt",
      badge1: "Gehirngesundheit",
      badge2: "Psychische Gesundheit",
      subtitle: "Wenn das Stimmungssystem des Gehirns im Leerlauf hängen bleibt",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche oder psychologische Betreuung. Wenn du oder jemand, den du kennst, Gefahr läuft, sich selbst zu verletzen, suche bitte dringend Hilfe bei lokalen Notdiensten oder einer Krisenhotline.",
    },
    ptsd: {
      title: "PTBS",
      desc: "Trauma verstehen, das Gehirn und Wege zur Erholung",
      badge1: "Gehirngesundheit",
      badge2: "Psychische Gesundheit",
      subtitle: "Trauma verstehen, das Gehirn und Wege zur Erholung",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche oder psychologische Betreuung. Wenn du mit Trauma-Symptomen kämpfst, wende dich bitte an eine qualifizierte Fachperson.",
    },
    feelingsEmotions: {
      title: "Gefühle & Emotionen",
      desc: "Wie das Gehirn emotionale Erfahrungen erzeugt und reguliert",
      badge1: "Grundlagen",
      badge2: "Psychische Gesundheit",
      subtitle: "Wie das Gehirn emotionale Erfahrungen erzeugt und reguliert",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine professionelle Beratung.",
    },
    senseOrgans: {
      title: "Sinnesorgane",
      desc: "Wie wir die Welt durch unsere Sinne wahrnehmen",
      badge1: "Grundlagen",
      badge2: "Gehirnwissenschaft",
      subtitle: "Wie wir die Welt durch unsere Sinne wahrnehmen",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine professionelle Beratung.",
    },
    painNociception: {
      title: "Schmerz & Nozizeption",
      desc: "Der Unterschied zwischen Gefahrenerkennung und Schmerzempfinden",
      badge1: "Grundlagen",
      badge2: "Gehirnwissenschaft",
      subtitle: "Der Unterschied zwischen Gefahrenerkennung und Schmerzempfinden",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche Beratung.",
    },
    microbiota: {
      title: "Mikrobiota & das Nervensystem",
      desc: "Wie Darmmikroben mit dem Gehirn kommunizieren und Stimmung, Kognition und Krankheit beeinflussen",
      badge1: "Grundlagen",
      badge2: "Gehirnwissenschaft",
      subtitle: "Wie Darmmikroben mit dem Gehirn kommunizieren und Stimmung, Kognition und Krankheit beeinflussen",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche Beratung.",
    },
    coffeeTea: {
      title: "Kaffee, Tee & das Gehirn",
      desc: "Was Koffein und Polyphenole für Wachheit, Schlaf und langfristige Gehirngesundheit bewirken",
      badge1: "Grundlagen",
      badge2: "Lebensstil",
      subtitle: "Was Koffein und Polyphenole für Wachheit, Schlaf und langfristige Gehirngesundheit bewirken",
      disclaimer: "Dieser Artikel dient nur der allgemeinen Bildung und ersetzt keine ärztliche Beratung.",
    },
  },
  
  // Games page
  games: {
    title: "Gehirntraining",
    subtitle: "Spielerische Herausforderungen für Aufmerksamkeit, Gedächtnis, Flexibilität und Problemlösung - mit Spaß.",
    categories: {
      memory: "Gedächtnis",
      attentionInhibition: "Aufmerksamkeit & Hemmung",
      speedFluency: "Geschwindigkeit & Flüssigkeit",
      visuoSpatial: "Visuell-Räumlich",
      fun: "Spaß",
    },
    disclaimer: "Haftungsausschluss: Diese Spiele dienen der Bildung und dem Spaß, nicht der medizinischen Diagnose. Bei gesundheitlichen Bedenken sprich bitte mit einer Fachperson.",
    backToHome: "Zurück zur Startseite",
    backToGames: "Zurück",
    playGame: "Spiel starten",
    comingSoon: "Demnächst",
    moreGamesDesc: "Weitere Spiele sind auf dem Weg! Bleib dran für neue Herausforderungen.",
    bestScore: "Bester Wert",
    playAgain: "Nochmal spielen",
    start: "Start",
    
    reactionDash: {
      title: "Reaktions-Dash",
      desc: "Teste deine Reflexe mit schnellen Tastendrücken",
      duration: "1-3 Min",
      instructions: "Klicke den Button so schnell wie möglich, wenn er grün wird. Klicke nicht zu früh!",
      startBtn: "Spiel starten",
      trial: "Versuch",
      of: "von",
      waitForGreen: "Warte auf Grün...",
      clickNow: "JETZT KLICKEN!",
      tooEarly: "Zu früh! Dieser zählt nicht.",
      getReady: "Mach dich bereit für den nächsten Versuch...",
      yourResults: "Deine Ergebnisse",
      averageTime: "Durchschnittliche Zeit",
      bestTime: "Beste Zeit",
      falseStarts: "Fehlstarts",
      feedback: {
        excellent: "Blitzschnelle Reflexe!",
        good: "Tolle Reaktionszeit!",
        ok: "Guter Einsatz!",
      },
      snapshot: "Dies ist nur eine Momentaufnahme deiner Verarbeitungsgeschwindigkeit. Viele Faktoren beeinflussen die Reaktionszeit.",
      interestingFact: "Interessanter Fakt",
      factText: "Bei einfachen Reaktionszeitaufgaben wie dieser reagieren viele Erwachsene in nur wenigen hundert Millisekunden. Das ist weniger als eine halbe Sekunde vom Sehen eines Signals bis zum Drücken eines Buttons. Die Reaktionszeit kann durch Schlaf, Stress, Ablenkung und sogar durch die Vertrautheit mit der Aufgabe beeinflusst werden.",
      tipTitle: "Tipp zur Verbesserung",
      tipText: "Um schnelle und zuverlässige Reaktionen zu unterstützen, konzentriere dich auf die Grundlagen: guter Schlaf, regelmäßige Bewegung und Reduzierung von Ablenkungen, wenn du schnell reagieren musst (zum Beispiel kein Telefonieren beim Fahren oder Radfahren). Das Üben einer Fähigkeit auf ruhige, fokussierte Weise kann auch helfen, dass Reaktionen automatischer werden.",
      playAgain: "Nochmal spielen",
      backToGames: "Zurück",
    },
    colourWord: {
      title: "Farb-Wort-Challenge",
      desc: "Ordne Farben zu und ignoriere den Text - eine Stroop-inspirierte Aufgabe",
      duration: "1-3 Min",
      disclaimer: "Haftungsausschluss: Dieses Spiel dient der Bildung und dem Spaß, nicht der medizinischen Diagnose. Bei gesundheitlichen Bedenken sprich bitte mit einer Fachperson.",
      howToPlay: "Wie man spielt",
      instructionsText: "Du siehst Wörter wie ROT, BLAU, GRÜN in verschiedenen Farben.",
      taskText: "Deine Aufgabe: Klicke den Button, der zur Farbe des Textes passt, nicht zum Wort.",
      exampleText: "Wenn du zum Beispiel siehst",
      clickText: ", klicke BLAU.",
      startBtn: "Start",
      trialOf: "Versuch {current} von {total}",
      clickInkColor: "Klicke die Tintenfarbe:",
      yourResults: "Deine Ergebnisse",
      correct: "Richtig",
      mistakes: "Fehler",
      averageReactionTime: "Durchschnittliche Reaktionszeit (richtige Versuche)",
      matchingTrials: "Übereinstimmende Versuche",
      conflictingTrials: "Konfligierende Versuche",
      excellentControl: "Ausgezeichnete kognitive Kontrolle!",
      goodPerformance: "Gute Leistung!",
      challenging: "Herausfordernd, oder?",
      suppressUrgeText: "Dein Gehirn musste den Drang unterdrücken, das Wort zu lesen, und stattdessen auf die Textfarbe achten.",
      interestingFact: "Interessanter Fakt",
      factText: "Der \"Stroop-Effekt\" wird seit Jahrzehnten in der Psychologie verwendet, um zu zeigen, wie unser Gehirn automatisch Wörter liest, selbst wenn wir versuchen, uns auf etwas anderes wie die Textfarbe zu konzentrieren. Es ist ein einfaches Beispiel dafür, wie automatische Gewohnheiten das stören können, worauf wir achten wollen.",
      tipTitle: "Tipp zur Verbesserung",
      tipText: "Du kannst diese Art der Konzentration unterstützen, indem du eine Aufgabe nach der anderen machst (statt starkem Multitasking), deinem Gehirn kurze Pausen gönnst und kleine Hinweise nutzt wie das Abschalten von Benachrichtigungen, wenn du dich konzentrieren musst.",
      playAgain: "Nochmal spielen",
      backToGames: "Zurück",
    },
    numberEcho: {
      title: "Zahlen-Echo",
      desc: "Merke und erinnere Zahlensequenzen",
      duration: "2-5 Min",
      disclaimer: "Diese Aktivität dient der Bildung und Selbstreflexion, nicht der medizinischen Diagnose.",
      howToPlay: "Wie man spielt",
      instructionsText: "Du siehst eine Sequenz von Ziffern, die nacheinander erscheinen.",
      taskText: "Schau genau hin und tippe sie in derselben Reihenfolge zurück!",
      startsWithText: "Beginne mit 3 Ziffern. Jedes Mal, wenn du richtig liegst, wird die Sequenz um eine Ziffer länger.",
      endsText: "Das Spiel endet, wenn du einen Fehler machst oder die maximale Länge erreichst.",
      startGame: "Spiel starten",
      sequenceLength: "Sequenzlänge:",
      watchCarefully: "Schau genau hin...",
      yourTurn: "Du bist dran",
      typeDigits: "Tippe die Ziffern ein, die du gesehen hast (ohne Leerzeichen)",
      enterDigits: "Ziffern eingeben...",
      submit: "Absenden",
      yourResults: "Deine Ergebnisse",
      maxDigitSpan: "Maximale Ziffernspanne",
      roundsCompleted: "Abgeschlossene Runden",
      goodStart: "Guter Start!",
      strongMemory: "Starkes Arbeitsgedächtnis!",
      impressiveMemory: "Beeindruckende Gedächtniskapazität!",
      averageSpanText: "Die durchschnittliche Ziffernspanne bei Erwachsenen beträgt 5-7 Ziffern. Kleine Schwankungen sind völlig normal und spiegeln weder allgemeine Intelligenz noch Fähigkeiten wider.",
      interestingFact: "Interessanter Fakt",
      factText: "Das Arbeitsgedächtnis ist das Gehirnsystem, mit dem du ein paar Informationen gleichzeitig festhalten und bearbeiten kannst, wie ein mentaler Notizblock. Forschung zeigt, dass wir in der Regel nur eine kleine Anzahl von Elementen gleichzeitig aktiv halten können, weshalb selbst einfache Ablenkungen dazu führen können, dass wir eine gerade gehörte Telefonnummer vergessen.",
      tipTitle: "Tipp zur Verbesserung",
      tipText: "Um das Arbeitsgedächtnis zu unterstützen, versuche Hintergrundablenkungen zu reduzieren, Informationen in kleinere \"Pakete\" zu unterteilen (z.B. 1-9-8-4 als zwei Paare statt vier einzelne Zahlen) und deinem Gehirn genug Schlaf und kurze Pausen bei anspruchsvollen Aufgaben zu gönnen.",
      playAgain: "Nochmal spielen",
      backToGames: "Zurück",
    },
    wordSprint: {
      title: "Wort-Sprint",
      desc: "Tippe so viele Wörter wie möglich in 60 Sekunden",
      duration: "1-2 Min",
      disclaimer: "Haftungsausschluss: Dieses Spiel dient der Bildung und dem Spaß, nicht der medizinischen Diagnose. Bei gesundheitlichen Bedenken sprich bitte mit einer Fachperson.",
      howToPlay: "Wie man spielt",
      instructionsText: "Wähle eine Kategorie und tippe so viele verschiedene Wörter wie möglich in 60 Sekunden.",
      typeOneWord: "Tippe ein Wort nach dem anderen und drücke Enter. Jedes einzigartige Wort zählt!",
      chooseCategory: "Wähle eine Kategorie:",
      category: "Kategorie",
      wordsEntered: "Eingegebene Wörter",
      seconds: "Sekunden",
      typeWord: "Wort eingeben...",
      add: "Hinzufügen",
      alreadyUsed: "Das Wort hast du schon verwendet!",
      yourWords: "Deine Wörter:",
      totalWords: "Wörter gesamt",
      yourResults: "Deine Ergebnisse",
      excellentFluency: "Dein Wortmotor ist warmgelaufen!",
      goodFluency: "Schöne Flüssigkeit!",
      okFluency: "Guter Einsatz!",
      feedbackText: "Schnelle Wortaufgaben wie diese nutzen Sprachnetzwerke im Gehirn und die \"exekutiven\" Systeme, die beim Suchen, Wechseln und Vermeiden von Wiederholungen helfen.",
      interestingFact: "Interessanter Fakt",
      factText: "Verbale Flüssigkeitstests werden häufig in Psychologie und Neurowissenschaft verwendet, um Sprachabruf, mentale Flexibilität und exekutive Kontrolle zu bewerten. Deine Fähigkeit, schnell Wörter zu generieren, hängt davon ab, wie effizient dein Gehirn semantisches Gedächtnis durchsuchen und wiederholte Antworten filtern kann.",
      tipTitle: "Tipp zur Verbesserung",
      tipText: "Um diese Art des Denkens zu unterstützen, helfen breites Lesen, neue Wörter in jeder Sprache lernen und kreative Aktivitäten (wie Geschichtenerzählen oder Spiele), die Sprachnetzwerke aktiv und flexibel zu halten.",
      playAgain: "Nochmal spielen",
      backToGames: "Zurück",
      categories: {
        animals: "Tiere",
        foods: "Lebensmittel",
        roundThings: "Runde Dinge",
        kitchenThings: "Dinge in der Küche",
        wearableThings: "Dinge zum Anziehen",
        vehicles: "Fahrzeuge",
        sportsGames: "Sport oder Spiele",
        emotions: "Emotionen/Gefühle",
        jobs: "Berufe",
        cityPlaces: "Orte in einer Stadt",
        countries: "Länder",
        weather: "Wetter",
      },
    },
    memoryGrid: {
      title: "Gedächtnis-Gitter",
      desc: "Merke und erinnere visuelle Muster",
      duration: "1-3 Min",
      disclaimer: "Haftungsausschluss: Dieses Spiel dient der Bildung und dem Spaß, nicht der medizinischen Diagnose. Bei gesundheitlichen Bedenken sprich bitte mit einer Fachperson.",
      howToPlay: "Wie man spielt",
      instructionsText: "Beobachte das Muster der aufgeleuchteten Quadrate und klicke dann dieselben Quadrate aus dem Gedächtnis.",
      eachLevel: "Jedes Level fügt ein weiteres Quadrat hinzu. Das Gitter kann mit dem Fortschritt größer werden!",
      level: "Level",
      watchCarefully: "Schau genau hin...",
      selectSquares: "Wähle {count} Quadrate",
      selected: "Ausgewählt",
      correct: "Richtig!",
      yourResults: "Deine Ergebnisse",
      highestLevel: "Höchstes Level",
      largestPattern: "Größtes Muster",
      excellentMemory: "Hervorragendes räumliches Gedächtnis!",
      goodMemory: "Tolle Leistung!",
      okMemory: "Guter Start!",
      reachedLevel: "Du hast Level {level} erreicht - das sind {pattern} Quadrate zum Merken!",
      interestingFact: "Interessanter Fakt",
      factText: "Dieses Spiel nutzt das visuell-räumliche Arbeitsgedächtnis - deine Fähigkeit, Positionen und Muster für einige Sekunden im Kopf zu behalten. Es ähnelt dem Erinnern, wo du Gegenstände in einem Raum abgelegt hast, oder der Orientierung an einem neuen Ort. Forschung zeigt, dass das visuell-räumliche Gedächtnis Netzwerke in den Scheitel- und Stirnlappen des Gehirns einbezieht.",
      tipTitle: "Tipp zur Verbesserung",
      tipText: "Um das visuell-räumliche Gedächtnis im Alltag zu unterstützen, nutze sowohl visuelle als auch verbale Hinweise (wie das laute Beschreiben von Wegen), reduziere Multitasking, wenn du dir merken musst, wo Dinge sind, und halte wichtige Räume aufgeräumt. Regelmäßiges Üben räumlicher Aufgaben und ausreichend Qualitätsschlaf helfen ebenfalls.",
      playAgain: "Nochmal spielen",
      backToGames: "Zurück",
    },
    quickReflex: {
      title: "Schneller Reflex",
      desc: "Teste deine visuelle Reaktionsgeschwindigkeit",
      duration: "Demnächst",
    },
    focusTap: {
      title: "Fokus-Tipp",
      desc: "Tippe auf Ziele, halte dich bei Fallen zurück.",
      duration: "1 Min",
      disclaimer: "Haftungsausschluss: Dieses Spiel dient der Bildung und dem Spaß, nicht der medizinischen Diagnose. Bei gesundheitlichen Bedenken sprich bitte mit einer Fachperson.",
      tapForTarget: "Tippe auf die Zielform und ignoriere alles andere.",
      roundLength: "Rundenlänge: 60 Sekunden",
      target: "ZIEL",
      traps: "FALLEN (ignorieren)",
      greenCircle: "Grüner Kreis",
      otherShapes: "Andere Formen/Farben",
      howToPlay: "Wie man spielt",
      shapesAppear: "Formen erscheinen nacheinander in der Mitte",
      tapOrClick: "Tippe/klicke oder drücke die Leertaste NUR für den grünen Kreis",
      doNothing: "Tue nichts bei allen anderen Formen",
      paceSpeedsUp: "Das Tempo steigt, je weiter du kommst!",
      startGame: "Spiel starten",
      getReady: "Mach dich bereit...",
      hits: "Treffer",
      falseAlarms: "Fehlalarme",
      tapHint: "Tippe auf den Formbereich oder drücke die Leertaste nur für grüne Kreise",
      yourResults: "Deine Ergebnisse",
      roundComplete: "Runde abgeschlossen!",
      accuracy: "Genauigkeit",
      focusTapScore: "Fokus-Tipp-Wertung",
      avgRT: "Durchschn. RZ",
      excellentFocus: "Hervorragender Fokus und Impulskontrolle! \uD83C\uDFAF",
      goodFocus: "Gut fokussiert geblieben! \uD83D\uDC4D",
      challengingFocus: "Herausfordernd, oder? Die Fallen können schwer zu widerstehen sein!",
      whatThisTrains: "Was das trainiert",
      trainsText: "Dies ist eine \"Go/No-Go\"-Aufgabe. Sie trainiert Reaktionshemmung - deine Fähigkeit, eine automatische Reaktion zu stoppen, wenn nötig. Diese Fähigkeit ist entscheidend für Impulskontrolle, Entscheidungsfindung und Selbstregulation im Alltag.",
      interestingFact: "Interessanter Fakt",
      factText: "Reaktionshemmung ist mit dem rechten präfrontalen Kortex verknüpft. Studien zeigen, dass selbst kleine Verbesserungen der Hemmungskontrolle bei Fokus, emotionaler Regulation und Ablenkungswiderstand helfen können.",
      tipTitle: "Tipps zur Verbesserung",
      tipText: "Übe im Alltag, vor dem Handeln innezuhalten. Selbst eine Sekunde Pause vor einer Reaktion kann die \"Stopp\"-Schaltkreise deines Gehirns stärken. Achtsamkeitsübungen, ausreichend Schlaf und das Vermeiden von Entscheidungsmüdigkeit unterstützen ebenfalls eine bessere Impulskontrolle.",
      playAgain: "Nochmal spielen",
      backToGames: "Zurück",
    },
    mathMinute: {
      title: "Mathe-Minute",
      desc: "Eine Minute schnelles Rechnen: addieren, subtrahieren, multiplizieren, dividieren.",
      duration: "1 Min",
      correctLabel: "richtig",
    },
    memoryCard: {
      title: "Gedächtnis-Karten",
      desc: "Klassisches Zuordnungsspiel - finde alle Paare!",
      duration: "2-5 Min",
      attemptsLabel: "Versuche",
    },
    numberSequence: {
      title: "Zahlenpfad",
      desc: "Klicke die Zahlen 1-25 der Reihe nach so schnell wie möglich.",
      duration: "1-2 Min",
    },
    targetShift: {
      title: "Zielverschiebung",
      desc: "Dein Gehirn kalibriert Bewegungen neu, wenn sich das Feedback ändert.",
      duration: "2-4 Min",
    },
    changeBlindness: {
      title: "Veränderungsblindheit",
      desc: "Finde die eine Sache, die sich nach dem Blitz verändert hat.",
      duration: "1-2 Min",
    },
    
    extrasTitle: "Extras",
    visitCafe: "Cafe besuchen",
    takePhotos: "Fotos machen",
    cafe: {
      title: "OMG Cafe",
      desc: "Bestelle ein Getränk, merke dir Wörter während es zubereitet wird, und schau wie viele du erinnerst.",
      duration: "5-10 Min",
    },
    photoBooth: {
      title: "Fotobox",
      desc: "Ein Tool zum Festhalten von Momenten. Mache 4 schnelle Schnappschüsse und bekomme einen Fotostreifen.",
      duration: "Nur zum Spaß",
    },
  },
  
  // Exercises page
  exercises: {
    title: "Sofort besser fühlen",
    subtitle: "Geführte Mikro-Übungen zur Stressreduktion, schärferen Konzentration und allgemeinen Gehirngesundheit.",
    disclaimer: "Haftungsausschluss: Diese Übungen dienen der Bildung und Selbstfürsorge, nicht der medizinischen Diagnose oder Behandlung. Bei gesundheitlichen Bedenken sprich bitte mit einer Fachperson.",
    backToExercises: "Zurück",
    backToHome: "Zurück zur Startseite",
    startExercise: "Übung starten",
    comingSoon: "Demnächst",
    moreExercisesDesc: "Weitere Übungen sind auf dem Weg! Bleib dran für neue Praktiken.",
    practiceAgain: "Nochmal üben",
    completeExercise: "Übung abschließen",
    youCanComplete: "Du kannst abschließen, wann immer du bereit bist",
    
    breathReset: {
      title: "Atem-Reset",
      tagline: "Folge dem Quadrat, um deine Atmung zu verlangsamen und deinen Geist zu beruhigen.",
      duration: "3 Minuten",
      description: "Eine geführte 3-minütige Atemübung, bei der du einem bewegten Quadrat folgst: einatmen, halten, ausatmen, halten.",
      explanation: "Dieses einfache \"Box-Breathing\"-Muster wird in vielen klinischen und Leistungskontexten verwendet, um das Nervensystem zu beruhigen. Du folgst einem bewegten Quadrat auf dem Bildschirm. Jede Seite des Quadrats leitet einen Teil des Atems: Einatmen, Halten, Ausatmen, Halten.",
      safetyNote: "Wenn du dich zu irgendeinem Zeitpunkt schwindelig oder unwohl fühlst, stoppe die Übung und kehre zu deiner natürlichen Atmung zurück.",
      whatTrainsTitle: "Was das trainiert:",
      whatTrains1: "Verlangsamt sanft Atmung und Herzfrequenz",
      whatTrains2: "Hilft dem Körper, in den \"Ruhe-und-Verdauungs\"-Zustand zu wechseln",
      whatTrains3: "Trainiert Bewusstsein für Körperempfindungen und Atem",
      inhale: "Einatmen",
      hold: "Halten",
      exhale: "Ausatmen",
      paused: "Pausiert",
      pause: "Pause",
      resume: "Fortsetzen",
      reset: "Zurücksetzen",
      instructions: "Folge der bewegten Kante mit deinen Augen. Atme ein, wenn das Quadrat \"Einatmen\" sagt, halte bei \"Halten\", atme aus bei \"Ausatmen\" und halte wieder. Versuche, deine Atmung sanft und nicht erzwungen zu halten.",
      nicelyDone: "Gut gemacht",
      completedMsg: "Du hast deinem Nervensystem gerade einen kurzen Reset gegeben.",
      noticeMsg: "Bemerke, wie sich dein Körper jetzt anfühlt - gibt es Veränderungen bei Spannung, Wärme oder Ruhe?",
      cyclesCompleted: "Du hast {count} vollständige Atemzyklen abgeschlossen",
    },
    awarenessCheckIn: {
      title: "Achtsamkeits-Check-In",
      subtitle: "Geist, Körper, Stimmung",
      tagline: "Nimm dir 2 Minuten, um zu bemerken, was in dir vorgeht, ohne etwas zu verändern.",
      duration: "2 Minuten",
      description: "Ein 2-minütiger Check-In, um zu bemerken, was in deinem Körper, Geist und deiner Stimmung passiert - ohne etwas reparieren zu wollen.",
      explanation: "Bewusstsein ist der erste Schritt zu sanfter Veränderung. Diese Übung hilft dir, einen kleinen \"Schnappschuss\" deiner inneren Welt zu machen - wie sich dein Körper anfühlt, was dein Geist tut und wie deine allgemeine Stimmung gerade ist.",
      whatTrainsTitle: "Was das trainiert:",
      whatTrains1: "Emotionales Bewusstsein",
      whatTrains2: "Interozeption (den Körper von innen spüren)",
      whatTrains3: "Selbstregulation",
      startCheckIn: "Check-In starten",
      body: "Körper",
      bodyScan: "Scanne deinen Körper von Kopf bis Fuß. Bemerke Spannung, Unruhe, Wärme oder Leichtigkeit - ohne etwas ändern zu wollen.",
      overallTension: "Allgemeine Körperspannung",
      tensionHint: "1 = sehr angespannt, 10 = sehr entspannt",
      veryTense: "Sehr angespannt",
      inBetween: "Dazwischen",
      veryRelaxed: "Sehr entspannt",
      whereTension: "Wo ist die Spannung? (alles Zutreffende auswählen)",
      tensionAreas: {
        headJaw: "Kopf / Kiefer",
        neck: "Nacken",
        shoulders: "Schultern",
        chest: "Brust",
        stomach: "Magen / Bauch",
        upperBack: "Oberer Rücken",
        lowerBack: "Unterer Rücken",
        armsHands: "Arme / Hände",
        legsFeet: "Beine / Füße",
        wholeBody: "Ganzer Körper",
        notSure: "Nicht sicher",
      },
      mind: "Geist",
      mindNotice: "Bemerke, wo dein Geist gerade die meiste Zeit verbringt. Ist er eher in der Vergangenheit, Gegenwart oder Zukunft?",
      past: "Vergangenheit",
      present: "Gegenwart",
      future: "Zukunft",
      noRightAnswer: "Es gibt hier keine richtige Antwort - bemerke einfach, wo dein Geist sich aufhält.",
      thoughtsLabel: "Möchtest du Gedanken notieren? (optional)",
      thoughtsPlaceholder: "Was geht dir gerade durch den Kopf...",
      mood: "Stimmung",
      moodQuestion: "Wenn deine Stimmung gerade eine Farbe und eine Zahl wäre, welche wären es?",
      chooseColor: "Wähle eine Farbe, die zu deiner Stimmung passt",
      selected: "Ausgewählt",
      overallMood: "Allgemeine Stimmung",
      veryLow: "Sehr niedrig",
      veryHigh: "Sehr hoch",
      moodDescLabel: "Beschreibe deine Stimmung in Worten (optional)",
      moodDescPlaceholder: "Wie würdest du beschreiben, wie du dich fühlst...",
      completeCheckIn: "Check-In abschließen",
      addPhoto: "Foto hinzufügen (optional)",
      addPhotoDesc: "Halte einen Moment fest - dich selbst oder deine Umgebung",
      takePhoto: "Foto machen",
      removePhoto: "Entfernen",
      snapshotTitle: "Dein Schnappschuss gerade",
      notSpecified: "Nicht angegeben",
      notSelected: "Nicht ausgewählt",
      mostlyIn: "Hauptsächlich in der",
      notYetSelected: "Noch nicht ausgewählt.",
      snapshotNote1: "Dies ist nur ein Schnappschuss - dein innerer Zustand ändert sich ständig, selbst innerhalb eines einzigen Tages.",
      snapshotNote2: "Solche Check-Ins helfen deinem Gehirn, über die Zeit Muster zu erkennen, ohne zu urteilen.",
      completeTitle: "Dein Achtsamkeits-Check-In",
      completeMsg: "Du musst gerade nichts ändern - einfach nur bemerken ist bereits ein kraftvoller Schritt für dein Gehirn und deine psychische Gesundheit.",
      checkInAgain: "Erneut einchecken",
      thoughts: "Gedanken",
      moodDescription: "Stimmung in Worten",
      moodColors: {
        grey: "Sanftes Grau",
        blue: "Ruhiges Blau",
        green: "Frisches Grün",
        yellow: "Warmes Gelb",
        orange: "Helles Orange",
        red: "Tiefes Rot",
        purple: "Sanftes Lila",
      },
    },
    fiveSenseGrounding: {
      title: "Fünf-Sinne-Erdung",
      tagline: "Komm zurück in die Gegenwart mit Sehen, Hören, Fühlen, Riechen und Schmecken.",
      duration: "3 Minuten",
      description: "Eine kurze Erdungsübung, die deine fünf Sinne nutzt, um dich in den gegenwärtigen Moment zurückzubringen.",
      explanation: "Wenn wir gestresst oder überwältigt sind, kann der Geist in Sorgen über Vergangenheit oder Zukunft kreisen. Diese Übung bringt die Aufmerksamkeit sanft zurück ins Hier und Jetzt, indem sie dich durch das führt, was du sehen, fühlen, hören, riechen und schmecken kannst.",
      whatTrainsTitle: "Was das trainiert:",
      whatTrains1: "Erdung im gegenwärtigen Moment",
      whatTrains2: "Stressreduktion",
      whatTrains3: "Sensorisches Bewusstsein",
      pattern: "5 - 4 - 3 - 2 - 1",
      see5: "5 Dinge, die du sehen kannst",
      see5Desc: "Schau dich um und benenne leise fünf Dinge, die du siehst. Sie können einfach sein: eine Tasse, ein Schatten, ein Buch, eine Farbe, deine Hände.",
      feel4: "4 Dinge, die du fühlen kannst",
      feel4Desc: "Bemerke vier Dinge, die du durch Berührung fühlen kannst - zum Beispiel deine Füße auf dem Boden, deine Kleidung auf der Haut, Luft im Gesicht oder die Textur eines Gegenstands in der Nähe.",
      hear3: "3 Dinge, die du hören kannst",
      hear3Desc: "Höre aufmerksam auf drei Geräusche - nah oder fern. Es könnte Verkehr sein, ein Kühlschranksummen, Vögel, ein Computerlüfter, deine eigene Atmung.",
      smell2: "2 Dinge, die du riechen kannst",
      smell2Desc: "Bemerke zwei Gerüche. Wenn du gerade nicht viel riechst, ist das okay - du kannst näher an etwas Duftendes herangehen (Seife, Kaffee, Handcreme) oder einfach den \"neutralen\" Geruch des Raumes bemerken.",
      taste1: "1 Sache, die du schmecken kannst",
      taste1Desc: "Bemerke eine Sache, die du schmecken kannst. Es könnte der Nachgeschmack eines Getränks sein, deine Zahnpasta oder einfach der natürliche Geschmack in deinem Mund. Wenn das schwer ist, kannst du dir auch einen Geschmack vorstellen, den du magst.",
      grounded: "Du bist geerdet",
      groundedMsg: "Du hast gerade deine Aufmerksamkeit im gegenwärtigen Moment mit deinen Sinnen verankert.",
      groundedNotice: "Bemerke, ob sich dein Körper oder Geist auch nur leicht anders anfühlt als zu Beginn.",
    },
    panicSOS: {
      title: "Panik-SOS - Die Welle reiten",
      tagline: "Schritt-für-Schritt-Anleitung, um eine Welle starker Angst zu überstehen.",
      duration: "3-5 Minuten",
      description: "Eine kurze Schritt-für-Schritt-Anleitung, um eine Welle starker Angst oder leichter Panik zu überstehen, bis sie vorübergeht.",
      explanation: "Panik und starke Angst können sich sehr intensiv und beängstigend anfühlen, aber die Empfindungen selbst sind in der Regel nicht gefährlich. Diese Übung hilft dir, bei der Welle zu bleiben und sie steigen, ihren Höhepunkt erreichen und abklingen zu lassen.",
      safetyTitle: "Wichtiger Sicherheitshinweis",
      safetyText: "Diese Übung ist für leichte bis mäßige Panik oder starke Angst gedacht. Wenn du Brustschmerzen, Atemnot hast, dich ohnmächtig fühlst, denkst, du könntest einen Herzinfarkt haben, oder Gedanken hast, dir selbst zu schaden - suche bitte sofort ärztliche Hilfe.",
      step1: "Benenne die Welle",
      step1Desc: "Benenne kurz, was passiert. Du brauchst keine Details - nur eine einfache Phrase.",
      step1Placeholder: "Panik in der Bahn, Angst vor einem Meeting...",
      intensityNow: "Wie intensiv fühlt es sich gerade an?",
      intensityScale: "0 = sehr niedrig, 10 = extrem hoch",
      step2: "Verankere deinen Körper",
      step2Desc: "Hilf deinem Nervensystem zu spüren, wo dein Körper gerade gestützt wird.",
      groundingOptions: {
        feet: "Beide Füße flach auf dem Boden",
        back: "Rücken an Stuhl oder Wand gestützt",
        hands: "Hände sanft zusammengepresst",
        ground: "Kontakt mit Boden oder Sitz bemerken",
      },
      chooseWhatPossible: "Du musst nicht alles machen - wähle einfach, was dir gerade möglich ist.",
      step3: "Atem sanft verlangsamen",
      step3Desc: "Lass deinen Atem sanft langsamer werden, ohne ihn zu erzwingen.",
      inhaleFor: "Atme durch die Nase ein, etwa 4 Sekunden.",
      exhaleFor: "Atme durch den Mund aus, etwa 6 Sekunden, als würdest du langsam eine Kerze auspusten.",
      breathsCompleted: "Atemzüge abgeschlossen",
      of: "von",
      start: "Start",
      breath: "+1 Atemzug",
      step4: "Schau dich um",
      step4Desc: "Lass deine Augen durch den Raum wandern. Benenne sanft, was wirklich hier ist, genau jetzt.",
      thingsISee: "3 Dinge, die ich sehen kann",
      thingsIFeel: "2 Dinge, die ich fühlen kann (Berührung)",
      thingsIHear: "1 Geräusch, das ich hören kann",
      step5: "Überprüfe die Welle",
      step5Desc: "Panikwellen steigen und fallen. Lass uns sehen, wie diese jetzt ist.",
      intensityBefore: "Vorher",
      intensityAfter: "Jetzt",
      waveDecreased: "Selbst eine kleine Veränderung ist ein Fortschritt. Gut gemacht, dass du bei der Welle geblieben bist.",
      waveSame: "Wenn sich nichts verändert hat, ist das auch okay. Die Welle wird trotzdem vorübergehen.",
      closingMsg: "Du bist gerade bei einer schwierigen Welle geblieben, anstatt dagegen anzukämpfen.",
      closingNote: "Wenn starke Angst oder Panik immer wieder kommt, erwäge ein Gespräch mit einem Psychologen oder Therapeuten.",
    },
    nightTimeWorry: {
      title: "Nächtliches Sorgen-Parken",
      tagline: "Bringe rasende Gedanken aus deinem Kopf und \"parke\" sie für morgen.",
      duration: "5 Minuten",
      description: "Eine kurze Übung, um Sorgen aus deinem Kopf auf \"geparkte\" Notizen für morgen zu bringen.",
      explanation: "Nachts beginnt das Gehirn oft, Probleme in einer Schleife abzuspielen. Sorgen aufzuschreiben und zu sortieren kann dem Geist helfen loszulassen für den Schlaf - in dem Wissen, dass das Morgen-Ich sie wieder aufnehmen kann.",
      step1: "Schreibe deine Sorgen auf",
      step1Desc: "Schreibe in ein paar kurzen Zeilen auf, wohin dein Geist immer wieder zurückkehrt. Eine Sorge pro Zeile genügt.",
      step1Placeholder: "Arbeitsfrist\nStreit mit Freund\nGeld\nArzttermin nächste Woche...",
      next: "Weiter",
      step2: "Sortiere deine Sorgen",
      step2Desc: "Frage dich bei jeder Sorge: \"Gibt es eine konkrete Handlung, die ich morgen tun kann?\" Wenn ja, notieren wir einen kleinen nächsten Schritt. Wenn nicht, markieren wir sie als Sorge, bei der du gerade nicht handeln kannst.",
      worryOf: "Sorge {current} von {total}",
      canActTomorrow: "Kann morgen handeln",
      cantActNow: "Kann gerade nicht handeln",
      smallestNextStep: "Kleinster nächster Schritt für morgen:",
      nextStepPlaceholder: "E-Mail senden an..., Konto prüfen, Liste erstellen...",
      previous: "Zurück",
      finish: "Fertig",
      step3: "Deine Sorgen sind geparkt",
      step3Desc: "Hier ist ein Schnappschuss dessen, was du für morgen geparkt hast. Wir speichern diese Daten nicht auf einem Server, also mache einen Screenshot oder kopiere den Text, bevor du die Seite schließt.",
      actionsForTomorrow: "Aktionen für morgen",
      letGoTonight: "Dinge, die du heute Nacht sanft loslassen kannst:",
      nextStepLabel: "Nächster Schritt",
      copyAll: "Alles in die Zwischenablage kopieren",
      copied: "In die Zwischenablage kopiert!",
      copyFailed: "Konnte nicht kopiert werden",
      closingMsg: "Du hast deinem Gehirn ein Signal gegeben:",
      closingMsg2: "\"Diese Sorgen sind aufgeschrieben. Ich kann morgen zu ihnen zurückkehren.\"",
      closingNote: "Deine einzige Aufgabe jetzt ist, dich auszuruhen. Wenn Schlafprobleme oder Angst sehr häufig oder stark sind, erwäge ein Gespräch mit einem Fachmann.",
    },
    cognitiveShuffle: {
      title: "Kognitives Mischen",
      tagline: "Ein sanfter mentaler Reset, wenn Gedanken nicht aufhören zu kreisen.",
      duration: "3-5 Minuten",
    },
    eisenhowerMatrix: {
      title: "Eisenhower-Matrix",
      tagline: "Priorisiere Aufgaben nach Dringlichkeit und Wichtigkeit.",
      duration: "5\u201315 Min",
    },
    photoBooth: {
      title: "Fotobox",
      tagline: "Ein Tool zum Festhalten von Momenten.",
      duration: "Nur zum Spaß",
    },
  },
  
  // Questionnaires page
  questionnaires: {
    title: "Check-ins",
    subtitle: "Wissenschaftsbasierte Selbstreflexions-Tools für Stimmung, Angst, Schlaf und Stresslevel.",
    disclaimer: "Haftungsausschluss",
    disclaimerText: "Diese Fragebögen stellen keine Diagnose dar und ersetzen keine professionelle ärztliche Beratung. Wenn deine Symptome dich beunruhigen oder den Alltag beeinträchtigen, sprich bitte mit einem Arzt, Psychologen oder einer qualifizierten Fachperson.",
    backToHome: "Zurück zur Startseite",
    backToQuestionnaires: "Zurück",
    returnToQuestionnaires: "Zurück",
    startQuestionnaire: "Fragebogen starten",
    estimatedTime: "Geschätzte Zeit",
    comingSoon: "Demnächst",
    moreQuestionnairesDesc: "Weitere Fragebögen sind in Arbeit! Bleib dran für neue Selbstreflexions-Tools.",
    scienceBased: "Wissenschaftsbasiert",
    ageRestriction: "Alter",
    years: "Jahre",
    plusYears: "+ Jahre",
    
    phq9: {
      title: "PHQ-9 - Stimmungs-Check-In",
      desc: "Ein kurzer, forschungsbasierter Stimmungsfragebogen, der dir hilft, häufige Symptome niedriger Stimmung der letzten 2 Wochen zu reflektieren.",
      time: "2-5 Minuten",
    },
    gad7: {
      title: "GAD-7 - Angst-Check-In",
      desc: "Ein kurzer, wissenschaftlicher Fragebogen über Sorgen und Angst der letzten 2 Wochen.",
      time: "2-4 Minuten",
    },
    pss10: {
      title: "PSS-10 - Stress-Check-In",
      desc: "Ein weit verbreiteter 10-Fragen-Fragebogen darüber, wie stressig und überfordernd sich das Leben im letzten Monat angefühlt hat.",
      time: "3-5 Minuten",
    },
    maas: {
      title: "MAAS - Achtsamkeits-Check-In",
      desc: "Ein kurzer Fragebogen darüber, wie oft du im Alltag präsent und aufmerksam bist.",
      time: "3-5 Minuten",
    },
    psqi: {
      title: "PSQI - Schlafqualitäts-Check-In",
      desc: "Ein forschungsbasierter Fragebogen über deine Schlafqualität im letzten Monat.",
      time: "5-7 Minuten",
    },
    ucla: {
      title: "UCLA-Einsamkeitsskala - Verbindungs-Check-In",
      desc: "Ein weit verbreiteter Fragebogen über Gefühle von Verbundenheit und Einsamkeit.",
      time: "5-7 Minuten",
    },
    cbi: {
      title: "CBI - Burnout-Check-In",
      desc: "Ein 19-Fragen-Fragebogen über persönliches, arbeitsbezogenes und klientenbezogenes Burnout.",
      time: "5-7 Minuten",
    },
    criq: {
      title: "CRIq - Gehirnreserve-Check-In",
      desc: "Ein Fragebogen über lebenslanges Lernen, Arbeit und Hobbys, die \"Gehirnreserve\" aufbauen. Besonders nützlich, wenn du über Gedächtnis und Altern nachdenkst.",
      time: "5-7 Minuten",
    },
    cllp: {
      title: "CLLP – Kognitive Belastung & Langlebigkeitsprofil",
      desc: "Ein umfassendes, wissenschaftlich fundiertes Profil Ihrer kognitiven Gesundheit — Schlaf, Stress, Aufmerksamkeit, Gedächtnis und mehr. Auf Ihre Antworten zugeschnitten. Vom ersten Tag an umsetzbar.",
      time: "25 Minuten",
    },
  },
  
  // Common questionnaire text
  questionnaire: {
    questionOf: "Frage {current} von {total}",
    back: "Zurück",
    next: "Weiter",
    seeResults: "Ergebnisse anzeigen",
    canStop: "Du kannst jederzeit aufhören. Deine Antworten werden nicht dauerhaft gespeichert.",
    outOf: "von {max} Punkten",
    outOfAvg: "von {max} (Durchschnittspunktzahl)",
    exploreNext: "Nächste Schritte mit Oh Mind Guide erkunden",
    
    // PHQ-9
    phq9: {
      title: "PHQ-9 - Stimmungs-Check-In",
      intro: "Wie oft wurden Sie in den letzten 2 Wochen von den folgenden Problemen belästigt?",
      resultTitle: "Dein Stimmungs-Check-In-Ergebnis (PHQ-9)",
      items: [
        "Wenig Interesse oder Freude an Aktivitäten",
        "Niedergeschlagenheit, Deprimiertheit oder Hoffnungslosigkeit",
        "Schwierigkeiten beim Ein- oder Durchschlafen, oder zu viel Schlafen",
        "Müdigkeit oder wenig Energie",
        "Appetitlosigkeit oder Überernährung",
        "Sich schlecht fühlen über sich selbst - oder dass man versagt hat oder sich selbst oder die Familie enttäuscht hat",
        "Konzentrationsschwierigkeiten, z.B. beim Lesen oder Fernsehen",
        "So langsam bewegen oder sprechen, dass andere es bemerken könnten. Oder das Gegenteil - so zappelig oder rastlos sein, dass man viel mehr herumläuft als üblich",
        "Gedanken, dass man besser tot wäre, oder sich selbst zu verletzen",
      ],
      categories: {
        low: "Niedriger Bereich",
        mild: "Leichter Bereich",
        moderate: "Mittlerer Bereich",
        high: "Hoher Bereich",
        veryHigh: "Sehr hoher Bereich",
      },
      descriptions: {
        low: "Deine Antworten liegen im unteren Bereich für Stimmungssymptome bei diesem Fragebogen.",
        mild: "Du hast einige stimmungsbezogene Symptome angegeben.",
        moderate: "Du hast eine Reihe von Stimmungssymptomen angegeben, die im mittleren Bereich dieses Fragebogens liegen.",
        high: "Dein Wert liegt im hohen Bereich für Stimmungssymptome bei diesem Fragebogen.",
        veryHigh: "Dein Wert liegt im sehr hohen Bereich für Stimmungssymptome bei diesem Fragebogen.",
      },
      recommendations: {
        low: [
          "Jeder hat Höhen und Tiefen, aber gerade berichtest du nicht viele der typischen Symptome, nach denen diese Skala fragt.",
          "Pflege weiterhin gesunde Routinen wie regelmäßigen Schlaf, körperliche Aktivität und soziale Kontakte.",
          "Erkunde unsere Gehirngesundheitsartikel und sanften Spiele zur Unterstützung deines Wohlbefindens.",
        ],
        mild: [
          "Das bedeutet nicht automatisch, dass du eine Depression hast, aber es ist ein Signal, auf dein Befinden zu achten.",
          "Erwäge sanfte Selbstfürsorge: halte einen regelmäßigen Schlafrhythmus ein, bewege dich und plane kleine erfreuliche Aktivitäten.",
          "Mit einer vertrauten Person zu sprechen kann helfen.",
          "Wenn diese Gefühle länger als 2 Wochen anhalten oder schlimmer werden, erwäge ein Gespräch mit einer Fachperson.",
        ],
        moderate: [
          "Dies kann ein Zeichen dafür sein, dass deine emotionale Last gerade ziemlich schwer ist.",
          "Wir empfehlen dringend, bald mit einem Arzt oder einer Fachperson für psychische Gesundheit zu sprechen, besonders wenn die Symptome seit mehreren Wochen anhalten oder Arbeit, Studium oder Beziehungen beeinträchtigen.",
          "Hilfe zu suchen ist ein Zeichen dafür, dass man Gehirngesundheit ernst nimmt, keine Schwäche.",
          "Pflege weiterhin die Selbstfürsorge-Basics: Schlaf, Ernährung, sanfte Bewegung und Kontakt mit anderen.",
        ],
        high: [
          "Dies deutet darauf hin, dass du erheblichen emotionalen Stress erlebst.",
          "Bitte sprich so bald wie möglich mit einem Arzt oder einer Fachperson für psychische Gesundheit.",
          "Wenn die Symptome Hoffnungslosigkeit, sehr geringe Motivation oder Gedanken an Selbstverletzung umfassen, ist Hilfe suchen dringend.",
          "Du verdienst Unterstützung, und wirksame Behandlungen sind verfügbar.",
        ],
        veryHigh: [
          "Dies weist auf schwere Symptome hin, die professionelle Aufmerksamkeit erfordern.",
          "Bitte kontaktiere sofort einen Arzt, Therapeuten oder einen psychischen Krisendienst.",
          "Wenn du Gedanken an Selbstverletzung hast, wende dich bitte sofort an den Notdienst oder eine Krisenhotline.",
          "Genesung ist mit der richtigen Unterstützung und Behandlung möglich.",
        ],
      },
      suicideRisk: {
        title: "Dringend: Bitte suche Hilfe",
        text: "Da du Gedanken an Selbstverletzung oder den Wunsch, nicht mehr hier zu sein, angegeben hast, ist es sehr wichtig, so bald wie möglich mit jemandem zu sprechen.",
        ifAtRisk: "Wenn du Gefahr läufst, dir selbst zu schaden, kontaktiere bitte:",
        contacts: [
          "Notdienste (112 oder 911)",
          "Eine lokale Krisen- oder Suizidhotline",
          "Deinen Arzt oder Therapeuten",
          "Eine vertraute Person aus Familie oder Freundeskreis",
        ],
      },
      nextSteps: {
        articlesTitle: "Artikel lesen",
        articlesDesc: "Erkunde wissenschaftsbasierte Ratgeber über Stimmung, Schlaf und Gehirnresilienz",
        gamesTitle: "Gehirnspiele ausprobieren",
        gamesDesc: "Trainiere dein Gehirn sanft mit spielerischen, wissenschaftsbasierten Übungen",
      },
    },
    
    // GAD-7
    gad7: {
      title: "GAD-7 - Angst-Check-In",
      intro: "Wie oft wurden Sie in den letzten 2 Wochen von den folgenden Problemen belästigt?",
      resultTitle: "Dein Angst-Check-In-Ergebnis (GAD-7)",
      items: [
        "Nervosität, Ängstlichkeit oder Anspannung",
        "Nicht in der Lage zu sein, Sorgen zu stoppen oder zu kontrollieren",
        "Übertriebene Sorgen über verschiedene Dinge",
        "Schwierigkeiten beim Entspannen",
        "So rastlos sein, dass es schwer ist, still zu sitzen",
        "Leicht reizbar oder ärgerlich werden",
        "Angst haben, als ob etwas Schreckliches passieren könnte",
      ],
      categories: {
        low: "Niedriger Bereich",
        mild: "Leichter Bereich",
        moderate: "Mittlerer Bereich",
        high: "Hoher Bereich",
      },
      descriptions: {
        low: "Deine Antworten deuten auf ein niedriges Niveau von Angstsymptomen bei diesem Fragebogen hin.",
        mild: "Du hast einige Angst oder Sorgen angegeben.",
        moderate: "Deine Antworten liegen im mittleren Bereich für Angstsymptome bei diesem Fragebogen.",
        high: "Dein Wert liegt im hohen Bereich für Angstsymptome bei diesem Fragebogen.",
      },
      recommendations: {
        low: [
          "Du berichtest im Moment nicht viele angstbezogene Symptome.",
          "Pflege weiterhin gesunde Gewohnheiten, die dein Wohlbefinden unterstützen.",
          "Erkunde unsere Inhalte zu Gehirnresilienz und Stressprävention.",
        ],
        mild: [
          "Viele Menschen erleben das in stressigen Zeiten, aber es ist nützlich, es im Auge zu behalten.",
          "Probiere einfache Atem- oder Erdungsübungen, wenn du merkst, dass die Angst steigt.",
          "Lies unsere Artikel zum Verstehen von Sorgen und der Stressreaktion.",
          "Wenn die Angst anhaltend ist oder belastet, erwäge ein Gespräch mit einer Fachperson.",
        ],
        moderate: [
          "Dies kann bedeuten, dass Angst viel mentalen Raum einnimmt.",
          "Wir empfehlen, mit einer Fachperson über das zu sprechen, was du erlebst.",
          "Ein Unterstützungsnetzwerk mit Freunden, Familie oder Gruppen aufzubauen kann helfen.",
          "Erkunde Entspannungstechniken und nervensystemberuhigende Praktiken.",
        ],
        high: [
          "Dies deutet darauf hin, dass du erhebliche Angst erlebst, die den Alltag beeinträchtigen könnte.",
          "Bitte sprich bald mit einem Arzt oder einer Fachperson für psychische Gesundheit.",
          "Angst ist sehr gut behandelbar, und wirksame Therapien und Unterstützung sind verfügbar.",
          "In der Zwischenzeit pflege sanfte Selbstfürsorge und wende dich an vertraute Personen.",
        ],
      },
      nextSteps: {
        articlesTitle: "Artikel lesen",
        articlesDesc: "Erfahre mehr über Angst, Stressreaktion und Beruhigungstechniken",
        gamesTitle: "Gehirnspiele ausprobieren",
        gamesDesc: "Übe Aufmerksamkeit und Achtsamkeit mit sanften Übungen",
      },
    },
    
    // PSS-10
    pss10: {
      title: "PSS-10 - Stress-Check-In",
      intro: "Im letzten Monat, wie oft haben Sie...",
      resultTitle: "Dein Stress-Check-In-Ergebnis (PSS-10)",
      items: [
        "Sich aufgeregt, weil etwas Unerwartetes passiert ist?",
        "Das Gefühl gehabt, dass du die wichtigen Dinge in deinem Leben nicht kontrollieren kannst?",
        "Dich nervös und gestresst gefühlt?",
        "Dich zuversichtlich gefühlt, persönliche Probleme zu bewältigen?",
        "Das Gefühl gehabt, dass die Dinge nach deinem Plan laufen?",
        "Festgestellt, dass du nicht mit allem fertig wirst, was du tun musst?",
        "In der Lage gewesen, Ärgernisse in deinem Leben zu kontrollieren?",
        "Das Gefühl gehabt, alles im Griff zu haben?",
        "Dich geärgert über Dinge, die außerhalb deiner Kontrolle lagen?",
        "Das Gefühl gehabt, dass sich Schwierigkeiten so auftürmen, dass du sie nicht überwinden kannst?",
      ],
      categories: {
        low: "Niedriger wahrgenommener Stress",
        moderate: "Moderater wahrgenommener Stress",
        high: "Hoher wahrgenommener Stress",
      },
      descriptions: {
        low: "Dein Wert liegt im unteren Bereich für wahrgenommenen Stress im letzten Monat.",
        moderate: "Dein Wert liegt im mittleren Bereich für wahrgenommenen Stress.",
        high: "Dein Wert liegt im oberen Bereich für wahrgenommenen Stress auf dieser Skala.",
      },
      recommendations: {
        low: [
          "Du bewältigst die Anforderungen des Lebens gerade relativ gut.",
          "Pflege weiterhin Routinen und Resilienz-Gewohnheiten.",
          "Erkunde unsere Inhalte zum gehirnschützenden Lebensstil: Schlaf, Bewegung und kognitive Aktivität.",
        ],
        moderate: [
          "Das ist üblich, wenn das Leben geschäftig oder anspruchsvoll ist.",
          "Erwäge kleine, konkrete Stressmanagement-Schritte: Pausen planen, Grenzen setzen und kurze Entspannungspraktiken.",
          "Achte darauf, ob Stress beginnt, Schlaf, Stimmung oder Konzentration zu beeinträchtigen.",
          "Wenn der Stress anhaltend oder überwältigend ist, erwäge ein Gespräch mit einer Fachperson.",
        ],
        high: [
          "Dies deutet darauf hin, dass sich das Leben in letzter Zeit ziemlich überwältigend angefühlt hat.",
          "Wir empfehlen dringend, professionelle Unterstützung in Betracht zu ziehen (Arzt, Therapeut, Berater).",
          "Versuche, deine Last zu reduzieren, wo möglich: bitte um Hilfe, delegiere Aufgaben und setze Prioritäten.",
          "Übe Selbstmitgefühl und denke daran, dass hoher Stress ein Signal zum Handeln ist.",
          "Erkunde unsere Ressourcen über Stress, Burnout und Erholung.",
        ],
      },
      disclaimerNote: "Er misst deine Wahrnehmung von Stress, die subjektiv ist und von Tag zu Tag variieren kann.",
      nextSteps: {
        articlesTitle: "Artikel lesen",
        articlesDesc: "Erfahre mehr über Stress, Gehirnresilienz und Erholungsstrategien",
        gamesTitle: "Gehirnspiele ausprobieren",
        gamesDesc: "Kleine Schritte für einen ruhigeren Geist mit spielerischen Übungen",
      },
    },
    
    // MAAS
    maas: {
      title: "MAAS - Achtsamkeits-Check-In",
      intro: "Bitte gib an, wie häufig oder selten du derzeit jede dieser Erfahrungen machst.",
      resultTitle: "Dein Achtsamkeits-Check-In (MAAS)",
      items: [
        "Ich könnte eine Emotion erleben und mir erst später bewusst werden.",
        "Ich breche oder verschütte Dinge aus Unachtsamkeit, Unaufmerksamkeit oder weil ich an etwas anderes denke.",
        "Ich finde es schwierig, mich auf das zu konzentrieren, was gerade passiert.",
        "Ich neige dazu, schnell zu gehen, um dorthin zu kommen, wo ich hinmuss, ohne darauf zu achten, was ich unterwegs erlebe.",
        "Ich neige dazu, Gefühle körperlicher Anspannung oder Unbehagen erst zu bemerken, wenn sie wirklich meine Aufmerksamkeit erregen.",
        "Ich vergesse den Namen einer Person fast sofort, nachdem man ihn mir gesagt hat.",
        "Ich scheine \"auf Autopilot\" zu laufen, ohne viel Bewusstsein für das, was ich tue.",
        "Ich hetze durch Aktivitäten, ohne wirklich aufmerksam zu sein.",
        "Ich konzentriere mich so auf das Ziel, das ich erreichen will, dass ich den Kontakt verliere zu dem, was ich gerade tue, um es zu erreichen.",
        "Ich erledige Aufgaben automatisch, ohne mir bewusst zu sein, was ich tue.",
        "Ich ertappe mich dabei, jemandem nur mit einem Ohr zuzuhören und gleichzeitig etwas anderes zu tun.",
        "Ich fahre \"auf Autopilot\" irgendwohin und frage mich dann, warum ich dorthin gefahren bin.",
        "Ich ertappe mich dabei, mit der Zukunft oder der Vergangenheit beschäftigt zu sein.",
        "Ich ertappe mich dabei, Dinge zu tun, ohne aufzupassen.",
        "Ich snacke, ohne mir bewusst zu sein, dass ich esse.",
      ],
      categories: {
        low: "Niedrigere alltägliche Achtsamkeit",
        moderate: "Moderate alltägliche Achtsamkeit",
        high: "Höhere alltägliche Achtsamkeit",
      },
      descriptions: {
        low: "Deine Antworten deuten darauf hin, dass du dich oft auf \"Autopilot\" befindest oder vom gegenwärtigen Moment abgelenkt bist.",
        moderate: "Deine Antworten liegen im mittleren Bereich für alltägliche Achtsamkeit. Du hast einige Momente der Präsenz und einige Momente des Autopiloten - das ist sehr verbreitet.",
        high: "Deine Antworten deuten darauf hin, dass du oft bewusst wahrnimmst, was im gegenwärtigen Moment geschieht. Dieses Maß an Achtsamkeit kann emotionales Gleichgewicht und Gehirngesundheit unterstützen.",
      },
      recommendations: {
        low: [
          "Das ist in unserem geschäftigen Leben sehr verbreitet, und es gibt kein Urteil - es ist einfach Information.",
          "Probiere kurze, zugängliche Achtsamkeitspraktiken (1-3 Minuten achtsames Atmen oder Empfindungen bemerken).",
          "Baue kleine Momente der Achtsamkeit in den Alltag ein - wie das Bemerken des Wassergefühls beim Händewaschen.",
          "Erkunde unsere Achtsamkeitsartikel und Erdungsübungen.",
        ],
        moderate: [
          "Erwäge, etwas mehr bewusste Aufmerksamkeit in deinen Alltag einzubauen.",
          "Probiere eine einfache wöchentliche Challenge: eine achtsame Aktivität pro Tag (achtsames Gehen, Essen oder Zuhören).",
          "Lies unsere Artikel darüber, wie Achtsamkeit Gehirnresilienz, Stressmanagement und Aufmerksamkeit unterstützt.",
          "Übe Neugierde statt Kritik, wenn dein Geist wandert.",
        ],
        high: [
          "Pflege diese Gewohnheiten weiter - sie schützen dein Wohlbefinden.",
          "Erwäge, fortgeschrittenere oder spielerische Achtsamkeitsübungen zu erkunden (achtsames Zuhören, achtsame Kommunikation).",
          "Teile deine Praxis mit anderen, denen sie nützen könnte.",
          "Probiere unsere Aufmerksamkeitsspiele, die Präsenz im Moment trainieren.",
        ],
      },
      disclaimerNote: "Dieses Ergebnis dient der Reflexion und persönlichen Entwicklung, nicht einer klinischen Bewertung oder Diagnose. Die MAAS misst Gegenwartsmoment-Bewusstsein im Alltag. Es ist ein Werkzeug unter vielen zum Verstehen deiner Erfahrung.",
      nextStepsTitle: "Kleine Schritte für einen ruhigeren, präsenteren Geist",
      nextSteps: {
        articlesTitle: "Achtsamkeits-Artikel",
        articlesDesc: "Erfahre mehr über Aufmerksamkeit, Gehirnresilienz und Gegenwartsmoment-Bewusstsein",
        gamesTitle: "Aufmerksamkeitsspiele",
        gamesDesc: "Trainiere deinen Fokus und Gegenwartsmoment-Bewusstsein mit spielerischen Übungen",
      },
    },
    
    // PSQI
    psqi: {
      title: "PSQI - Schlafqualitäts-Check-In",
      intro: "Die folgenden Fragen beziehen sich nur auf deine üblichen Schlafgewohnheiten während des letzten Monats.",
      resultTitle: "Dein Schlaf-Check-In (PSQI)",
      questions: {
        bedtime: "Wann bist du im letzten Monat normalerweise abends ins Bett gegangen?",
        fallAsleep: "Wie lange (in Minuten) hat es im letzten Monat normalerweise gedauert, bis du eingeschlafen bist?",
        wakeTime: "Wann bist du im letzten Monat normalerweise morgens aufgestanden?",
        sleepHours: "Wie viele Stunden tatsächlichen Schlaf hast du im letzten Monat nachts bekommen? (Dies kann sich von der Zeit im Bett unterscheiden.)",
        qualityOverall: "Wie würdest du deine Schlafqualität insgesamt im letzten Monat bewerten?",
        troubleSleepWithin30: "Wie oft hattest du im letzten Monat Schlafprobleme, weil du nicht innerhalb von 30 Minuten einschlafen konntest?",
        wakeUpMiddle: "Wie oft hattest du im letzten Monat Schlafprobleme, weil du mitten in der Nacht oder früh morgens aufgewacht bist?",
        medication: "Wie oft hast du im letzten Monat Medikamente (verschrieben oder freiverkäuflich) zum Einschlafen genommen?",
        troubleStayingAwake: "Wie oft hattest du im letzten Monat Schwierigkeiten, beim Autofahren, Essen oder bei sozialen Aktivitäten wach zu bleiben?",
        enthusiasm: "Wie sehr war es im letzten Monat ein Problem für dich, genug Begeisterung aufzubringen, um Dinge zu erledigen?",
      },
      qualityOptions: {
        veryGood: "Sehr gut",
        fairlyGood: "Ziemlich gut",
        fairlyBad: "Ziemlich schlecht",
        veryBad: "Sehr schlecht",
      },
      frequencyOptions: {
        notDuringPastMonth: "Nicht im letzten Monat",
        lessThanOnce: "Weniger als einmal pro Woche",
        onceOrTwice: "Ein- oder zweimal pro Woche",
        threeOrMore: "Dreimal oder öfter pro Woche",
      },
      problemOptions: {
        noProblem: "Überhaupt kein Problem",
        slightProblem: "Nur ein sehr leichtes Problem",
        somewhatProblem: "Ein gewisses Problem",
        bigProblem: "Ein sehr großes Problem",
      },
      enterNumber: "Zahl eingeben",
      categories: {
        good: "Gute Schlafqualität",
        some: "Einige Schlafprobleme",
        significant: "Erhebliche Schlafprobleme",
      },
      descriptions: {
        good: "Dein Wert liegt in dem Bereich, der normalerweise mit besserer Schlafqualität verbunden wird. Du könntest trotzdem gelegentlich schlechte Nächte haben - das ist normal - aber insgesamt erkennt dieser Fragebogen keine größeren Schlafprobleme.",
        some: "Dein Wert deutet darauf hin, dass du in letzter Zeit einige Schlafprobleme hattest. Dazu könnten längeres Einschlafen, nächtliches Aufwachen oder Tagesmüdigkeit gehören.",
        significant: "Dein Wert liegt in einem Bereich, in dem viele Menschen feststellen, dass Schlafprobleme ihre Tagesenergie, Stimmung oder Konzentration merklich beeinträchtigen.",
      },
      recommendations: {
        good: [
          "Pflege gesunde Schlafgewohnheiten: konstanter Zeitplan, Lichtexposition tagsüber und Bewegung.",
          "Halte dein Schlafzimmer kühl, dunkel und ruhig.",
          "Erkunde unsere Schlaf-Inhalte zum langfristigen Schutz deiner Schlafgesundheit.",
          "Denke daran, dass Stress oder Lebensveränderungen den Schlaf vorübergehend beeinträchtigen können.",
        ],
        some: [
          "Probiere einfache Schlafhygiene-Änderungen: eine Abendroutine, Bildschirmzeit vor dem Schlafen reduzieren, regelmäßige Aufstehzeit.",
          "Führe eine Woche lang ein Schlaftagebuch, um Muster zu erkennen.",
          "Erkunde unsere Entspannungsübungen vor dem Schlafengehen.",
          "Wenn Schlafprobleme anhalten oder sich verschlechtern, erwäge ein Gespräch mit einer Fachperson.",
          "Prüfe, ob Stress, Sorgen oder körperliche Beschwerden deinen Schlaf beeinträchtigen.",
        ],
        significant: [
          "Wir empfehlen dringend, deine Schlafprobleme mit einem Arzt oder Schlafspezialisten zu besprechen.",
          "Schlafprobleme sind häufig und behandelbar - du musst schlechten Schlaf nicht als \"normal\" akzeptieren.",
          "Erkunde kognitive Verhaltenstherapie für Schlaflosigkeit (KVT-I), die sehr wirksam ist.",
          "Lies unsere Artikel über Schlaflosigkeit, zirkadianen Rhythmus und Stress-Schlaf-Wechselwirkungen.",
          "In der Zwischenzeit halte eine konstante Aufstehzeit ein und vermeide lange Tagesschläfchen.",
        ],
      },
      disclaimerNote: "Er misst deine subjektive Schlafqualität, die wichtig ist, aber keine klinische Schlafuntersuchung ersetzt. Wenn Schlafprobleme anhalten oder schwerwiegend sind, oder wenn du eine Schlafstörung (wie Schlafapnoe) vermutest, sprich bitte mit einer Fachperson.",
      nextStepsTitle: "Kleine Experimente zur sanften Verbesserung deines Schlafs",
      nextSteps: {
        articlesTitle: "Schlaf-Artikel",
        articlesDesc: "Erfahre mehr über Schlafhygiene, zirkadianen Rhythmus und Entspannungstechniken",
        gamesTitle: "Beruhigende Übungen",
        gamesDesc: "Probiere sanfte Aktivitäten für die Tagesfunktion und nächtliche Entspannung",
      },
    },
    
    // UCLA
    ucla: {
      title: "UCLA-Einsamkeitsskala - Verbindungs-Check-In",
      intro: "Bitte gib an, wie oft du dich so fühlst, wie in jeder Aussage beschrieben.",
      resultTitle: "Dein Verbindungs-Check-In (UCLA-Einsamkeitsskala)",
      items: [
        "Wie oft fühlst du dich mit den Menschen um dich herum \"auf einer Wellenlänge\"?",
        "Wie oft fühlst du, dass dir Gesellschaft fehlt?",
        "Wie oft fühlst du, dass es niemanden gibt, an den du dich wenden kannst?",
        "Wie oft fühlst du dich allein?",
        "Wie oft fühlst du dich als Teil einer Freundesgruppe?",
        "Wie oft fühlst du, dass du viel mit den Menschen um dich herum gemeinsam hast?",
        "Wie oft fühlst du, dass du niemandem mehr nahe bist?",
        "Wie oft fühlst du, dass deine Interessen und Ideen nicht von den Menschen um dich herum geteilt werden?",
        "Wie oft fühlst du dich kontaktfreudig und freundlich?",
        "Wie oft fühlst du dich Menschen nahe?",
        "Wie oft fühlst du dich ausgeschlossen?",
        "Wie oft fühlst du, dass deine Beziehungen zu anderen nicht bedeutsam sind?",
        "Wie oft fühlst du, dass dich niemand wirklich gut kennt?",
        "Wie oft fühlst du dich von anderen isoliert?",
        "Wie oft fühlst du, dass du Gesellschaft finden kannst, wenn du willst?",
        "Wie oft fühlst du, dass es Menschen gibt, die dich wirklich verstehen?",
        "Wie oft fühlst du dich schüchtern?",
        "Wie oft fühlst du, dass Menschen um dich herum sind, aber nicht bei dir?",
        "Wie oft fühlst du, dass es Menschen gibt, mit denen du reden kannst?",
        "Wie oft fühlst du, dass es Menschen gibt, an die du dich wenden kannst?",
      ],
      categories: {
        low: "Niedrigerer Bereich für Einsamkeitsgefühle",
        moderate: "Moderate Einsamkeitsgefühle",
        high: "Höhere Einsamkeitsgefühle",
      },
      descriptions: {
        low: "Deine Antworten deuten darauf hin, dass du dich insgesamt normalerweise recht verbunden mit anderen fühlst. Jeder kann sich manchmal einsam fühlen, und das ist völlig normal.",
        moderate: "Deine Antworten deuten darauf hin, dass du in letzter Zeit einige Gefühle von Einsamkeit oder Trennung erlebt hast. Das ist sehr verbreitet, besonders bei Übergängen, hohem Stress oder großen Lebensveränderungen.",
        high: "Deine Antworten deuten darauf hin, dass Einsamkeit in letzter Zeit ziemlich präsent in deinem Leben war. Sich isoliert zu fühlen kann emotional schwer sein und kann auch die Gehirn- und Körpergesundheit über die Zeit beeinträchtigen.",
      },
      recommendations: {
        low: [
          "Pflege bedeutungsvolle Beziehungen und Gemeinschaftsaktivitäten, die dir Freude bereiten.",
          "Bleibe neugierig darauf, bestehende Verbindungen zu vertiefen, anstatt nur neue zu suchen.",
          "Erkunde unsere Inhalte über soziales Engagement und Gehirngesundheit.",
          "Denke daran, dass die Qualität der Verbindung mehr zählt als die Quantität.",
        ],
        moderate: [
          "Erwäge kleine, realistische Schritte: eine Person kontaktieren, einer Hobbygruppe beitreten oder Online-Communities erkunden, die sich sicher anfühlen.",
          "Denke daran, dass Einsamkeit kein Charakterfehler ist - es ist ein Signal, wie Hunger oder Durst.",
          "Lies unsere Artikel über den Aufbau sozialer Verbindungen und die Überwindung sozialen Rückzugs.",
          "Wenn Einsamkeit anhaltend und schmerzhaft ist, erwäge ein Gespräch mit einem Therapeuten oder Berater.",
          "Freiwilligenarbeit oder strukturierte soziale Aktivitäten können regelmäßige Verbindung bieten.",
        ],
        high: [
          "Wir empfehlen dringend, Unterstützung zu suchen: vertraute Freunde/Familie, Selbsthilfegruppen oder eine Fachperson für psychische Gesundheit.",
          "Therapie (besonders Ansätze mit Fokus auf Beziehungen und soziale Angst) kann sehr hilfreich sein.",
          "Erwäge strukturierte Aktivitäten, die regelmäßige Verbindung bringen: Kurse, Gruppen, Freiwilligenarbeit.",
          "Kleine Schritte zählen: selbst eine bedeutungsvolle Interaktion pro Woche ist Fortschritt.",
          "Erkunde unsere Ressourcen über Verbindung, soziale Gesundheit und Einsamkeit.",
          "Denke daran, dass diese Gefühle berechtigt sind und Veränderung mit Unterstützung möglich ist.",
        ],
      },
      disclaimerNote: "Dieses Ergebnis beschreibt, wie du diese Skala beantwortet hast; es ist keine Diagnose. Einsamkeit ist eine subjektive Erfahrung, und dieser Fragebogen erfasst deine Wahrnehmung zu diesem Zeitpunkt. Wenn sich Einsamkeit überwältigend anfühlt oder deinen Alltag beeinträchtigt, kann ein Gespräch mit einer Fachperson helfen.",
      nextStepsTitle: "Wege, dich über die Zeit etwas weniger allein zu fühlen",
      nextSteps: {
        articlesTitle: "Verbindungs-Artikel",
        articlesDesc: "Erfahre mehr über soziale Gesundheit, den Aufbau von Verbindungen und die Überwindung von Isolation",
        gamesTitle: "Soziale Aktivitäten",
        gamesDesc: "Erkunde Aktivitäten, die Verbindung und gemeinsame Erlebnisse beinhalten",
      },
    },
    
    // Response options
    responses: {
      notAtAll: "Überhaupt nicht",
      severalDays: "An einzelnen Tagen",
      moreThanHalf: "An mehr als der Hälfte der Tage",
      nearlyEvery: "Beinahe jeden Tag",
      
      never: "Nie",
      almostNever: "Fast nie",
      sometimes: "Manchmal",
      fairlyOften: "Ziemlich oft",
      veryOften: "Sehr oft",
      
      almostAlways: "Fast immer",
      veryFrequently: "Sehr häufig",
      somewhatFrequently: "Ziemlich häufig",
      somewhatInfrequently: "Ziemlich selten",
      veryInfrequently: "Sehr selten",
      almostNeverMaas: "Fast nie",
      
      rarely: "Selten",
      often: "Oft",
    },
    
    // Common results text
    importantDisclaimer: "Wichtiger Hinweis",
    screeningTool: "Dieser Fragebogen ist ein Screening- und Reflexionswerkzeug, keine Diagnose.",
    cannotTell: "Er kann dir nicht sicher sagen, ob du eine psychische Erkrankung hast.",
    ifSymptomsWorry: "Wenn deine Symptome dich beunruhigen, deinen Alltag beeinträchtigen oder dein Wert in den höheren Bereichen liegt, erwäge ein Gespräch mit einem Arzt, Psychologen oder einer qualifizierten Fachperson.",
    
    crisisResources: "Krisenressourcen",
    crisisText: "Wenn du daran denkst, dir selbst zu schaden, oder du dich in unmittelbarer Gefahr fühlst, suche bitte sofort Hilfe:",
    crisisContacts: [
      "Kontaktiere lokale Notdienste (112 oder 911)",
      "Rufe eine lokale Krisen- oder Suizidhotline an",
      "Gehe in die nächste Notaufnahme",
    ],
    
    readArticles: "Artikel lesen",
    tryGames: "Gehirnspiele ausprobieren",
  },
  
  // Photo Booth
  photoBooth: {
    title: "Retro-Fotobox",
    subtitle: "Ein Tool zum Festhalten von Momenten: vier schnelle Schnappschüsse, ein Fotostreifen zum Behalten.",
    vintageSubtitle: "Vier schnelle Schnappschüsse, ein Fotostreifen zum Behalten.",
    description: "Tritt in eine kleine virtuelle Fotobox. Wenn du bereit bist, starte die Session, beobachte den Countdown und lass die Kamera vier Momente mit kleinen Pausen dazwischen festhalten. Am Ende erscheinen deine Fotos als Retro-Streifen, den du herunterladen und behalten kannst.",
    backToGames: "Zurück",
    boothTitle: "Retro-Fotobox",
    readyMessage: "Mach dich bereit - 4 Fotos hintereinander",
    cameraError: "Es scheint, als könnten wir nicht auf deine Kamera zugreifen. Bitte überprüfe deine Browsereinstellungen oder probiere ein anderes Gerät.",
    tryAgain: "Nochmal versuchen",
    photoOf: "Foto {current} von {total}",
    processing: "Dein Fotostreifen wird erstellt...",
    startSession: "Fotosession starten",
    download: "Fotostreifen herunterladen",
    downloadStrip: "Streifen herunterladen",
    retake: "Fotos wiederholen",
    privacyNote: "Deine Fotos bleiben auf deinem Gerät - wir speichern sie nicht.",
    privacyNotice: "Wir speichern deine Fotos nicht - sie bleiben auf deinem Gerät, sofern du sie nicht herunterlädst.",
    capturing: "Stillhalten, wird aufgenommen...",
    printing: "Deine Fotos werden gedruckt...",
  },
  
  // Sampler page
  sampler: {
    title: "Dein einzigartiger OMG-Sampler",
    subtitle: "Nur für dich zusammengestellt \u2728 (jederzeit mischen)",
    savedNote: "Auf diesem Gerät gespeichert.",
    shuffleAll: "Alles mischen",
    open: "Öffnen",
    shuffle: "Mischen",
    more: "Mehr",
    backToHome: "Zurück zur Startseite",
    back: "Zurück",
    showMeBtn: "Zeig mir, was du hast",
    
    categories: {
      game: "Spiel",
      exercise: "Übung",
      cafe: "OMG Cafe",
      questionnaire: "Fragebogen",
      article: "Artikel",
      photobooth: "Fotobox",
    },
    
    games: {
      colour: { title: "Farb-Wort-Challenge", desc: "Ordne Farben zu und ignoriere den Text" },
      number: { title: "Zahlen-Echo", desc: "Merke und erinnere Zahlensequenzen" },
      focustap: { title: "Fokus-Tipp", desc: "Tippe schnell und genau auf Ziele" },
      memorygrid: { title: "Gedächtnis-Gitter", desc: "Merke Muster auf einem Gitter" },
      mathminute: { title: "Mathe-Minute", desc: "Löse Matheaufgaben gegen die Uhr" },
      wordsprint: { title: "Wort-Sprint", desc: "Tippe Wörter so schnell wie möglich" },
      reaction: { title: "Reaktions-Dash", desc: "Teste deine Reflexe" },
      memorycard: { title: "Gedächtnis-Karten", desc: "Finde passende Paare" },
      numbersequence: { title: "Zahlenpfad", desc: "Klicke Zahlen 1-25 der Reihe nach" },
      targetshift: { title: "Zielverschiebung", desc: "Dein Gehirn kalibriert Bewegungen neu" },
      changeblindness: { title: "Veränderungsblindheit", desc: "Finde, was sich nach dem Blitz verändert hat" },
    },
    
    exercises: {
      boxbreathing: { title: "Box-Atmung", desc: "Eine beruhigende 4-4-4-4-Atemtechnik" },
      awarenesscheckin: { title: "Achtsamkeits-Check-In", desc: "Verbinde dich mit Körper und Geist" },
      fivesensegrounding: { title: "5-Sinne-Erdung", desc: "Erde dich mit allen fünf Sinnen" },
      panicsos: { title: "Panik-SOS", desc: "Schnelle Hilfe in überwältigenden Momenten" },
      nighttimeworry: { title: "N\u00e4chtliches Sorgen-Parken", desc: "Sorgen vor dem Schlaf loslassen" },
      cognitiveshuffle: { title: "Kognitives Mischen", desc: "Ein sanfter Reset, wenn Gedanken kreisen" },
      eisenhowermatrix: { title: "Eisenhower-Matrix", desc: "Aufgaben nach Dringlichkeit und Wichtigkeit priorisieren" },
      ambientstudio: { title: "Soundscape Studio", desc: "Mische deine perfekte Klanglandschaft" },
    },
    
    cafe: { title: "OMG Cafe", desc: "Bereite ein gemütliches Getränk zu & trainiere dein Gedächtnis" },
    
    questionnaires: {
      phq9: { title: "PHQ-9 Depressions-Screening", desc: "Depressionssymptome bewerten" },
      gad7: { title: "GAD-7 Angst-Screening", desc: "Angstniveau messen" },
      pss10: { title: "PSS-10 Stressskala", desc: "Wahrgenommenen Stress bewerten" },
      maas: { title: "MAAS Achtsamkeitsskala", desc: "Achtsamkeitsbewusstsein messen" },
      psqi: { title: "PSQI Schlafqualität", desc: "Schlafqualität bewerten" },
      ucla: { title: "UCLA Einsamkeitsskala", desc: "Einsamkeitsgefühle messen" },
      cbi: { title: "CBI Burnout-Check-In", desc: "Persönliches und arbeitsbezogenes Burnout bewerten" },
      criq: { title: "CRIq Gehirnreserve", desc: "Kognitive Reservefaktoren erkunden" },
    },
    
    articles: {
      "brain-and-mind": { title: "Gehirn & Geist", desc: "Grundlagen der Neurowissenschaft erkunden" },
      dementia: { title: "Demenz", desc: "Gedächtnis und kognitiven Abbau verstehen" },
      parkinsons: { title: "Parkinson-Krankheit", desc: "Bewegung, Dopamin und das Gehirn" },
      adhd: { title: "ADHS", desc: "Aufmerksamkeit, Fokus und exekutive Funktion" },
      sleep: { title: "Schlaf", desc: "Die Wissenschaft von Ruhe und Erholung" },
      autism: { title: "Autismus", desc: "Neurodiversität und einzigartige Perspektiven" },
      schizophrenia: { title: "Schizophrenie", desc: "Wahrnehmung, Realität und der Geist" },
      anxiety: { title: "Angst", desc: "Furcht und Sorge verstehen" },
      depression: { title: "Depression", desc: "Stimmung, Motivation und das Gehirn" },
      ptsd: { title: "PTBS", desc: "Trauma, Gedächtnis und Heilung" },
      "feelings-emotions": { title: "Gefühle & Emotionen", desc: "Die Wissenschaft hinter dem, was wir fühlen" },
      "pain-nociception": { title: "Schmerz & Nozizeption", desc: "Wie wir Schmerz wahrnehmen und verarbeiten" },
      "sense-organs": { title: "Sinnesorgane", desc: "Wie wir die Welt wahrnehmen" },
      microbiota: { title: "Mikrobiota & Nervensystem", desc: "Wie Darmmikroben mit dem Gehirn kommunizieren" },
      "coffee-tea": { title: "Kaffee, Tee & das Gehirn", desc: "Koffein, Polyphenole und Gehirngesundheit" },
    },
    
    photobooth: { title: "Fotobox", desc: "Ein Tool zum Festhalten von Momenten" },
    
    times: {
      "1min": "1 Min",
      "1-2min": "1-2 Min",
      "2-3min": "2-3 Min",
      "3-5min": "3-5 Min",
      "5min": "5 Min",
      "5-7min": "5-7 Min",
      "5-10min": "5-10 Min",
      "8-10min": "8-10 Min",
      "10-12min": "10-12 Min",
      "12-15min": "12-15 Min",
      justForFun: "Nur zum Spaß",
    },
  },
  
  // Next Steps cross-linking
  nextSteps: {
    title: "Nächste Schritte",
    openButton: "Öffnen",
    categoryLabels: {
      article: "Artikel",
      game: "Spiel",
      exercise: "Übung",
      questionnaire: "Fragebogen",
    },
  },
} as const;
